module.exports = __webpack_public_path__ + "img/125.c196ad43.jpg";